import * as angular from 'angular';
import { syncToGithubModalDirective } from './sync-to-github-modal-directive';
import { workspaceSettingsGithubDirective } from './workspace-settings-github.directive';

export const GithubFeatureSyncModalAngularJsModule = angular
  .module('github-feature-sync-modal', ['downgraded-shared-ui'])
  .directive('syncToGithubModal', syncToGithubModalDirective).name;

angular
  .module(GithubFeatureSyncModalAngularJsModule)
  .directive('workspaceSettingsGithubSync', workspaceSettingsGithubDirective);
